import "./Experience.module.css";
import Header from "@/reusable_sections/Header";
import TenYearsOfItChallenges from "./sections/TenYearsOfItChallenges";
import IlMetodoBTech from "./sections/IlMetodoBTech";
import ValoriEVisione from "./sections/ValoriEVisione";
import PièDiPagina from "@/reusable_sections/Footer";
export default function ExperiencePage() {
  return <div>
      <Header />
      <TenYearsOfItChallenges />
      <IlMetodoBTech />
      <ValoriEVisione />
      <PièDiPagina />
    </div>;
}